import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import TextInputField from "../../components/forms/TextInputField";
import BooleanInputField from "../../components/forms/BooleanInputField";
import FormError from "../../components/forms/FormError";

function toUpperCase(val) {
  return val && val.toUpperCase();
}

function toBoolean(val) {
  return val === true || val === "true";
}

class TaxInfoForm extends Component {

  render() {
    let {errors, handleSubmit, submitting} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 

    let description = "Enter a tax id that will be printed on invoices.";
    let validateField = null;
    if (this.props.showValidateTaxId) {
      validateField = (
        <Field
          label="EU Tax Id?"
          name="validateTaxId"
          placeholder=""
          normalize={toBoolean}
          component={BooleanInputField}
          serverError={this.props.errors.validateTaxId}
          />
      )
      description = `${description} If you have a European VIES tax number you must validate the tax id by choosing the option below.`
    }

    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <p>{description}</p>
          <FormFieldsTable>
            <Field
              label="Tax ID"
              name="taxId"
              placeholder=""
              normalize={toUpperCase}
              component={TextInputField}
              serverError={this.props.errors.taxId}
              />
            {validateField}
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton onClick={handleSubmit(values => this.props.onSubmit(values))} label={submitLabel} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "TaxInfoForm"
})(TaxInfoForm);

TaxInfoForm.defaultProps = {
  showValidateTaxId: false
}

export default ReduxForm;